export default __webpack_public_path__ + "static/media/13059 - CPyrc.4e6a6035.jpeg";